import Chart from 'chart.js/auto';
import svgPanZoom from 'svg-pan-zoom';

(async function () {

    let chart = new Chart(
        document.getElementById('historicGasData'),
        {
            type: 'line',
            options: {
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                        position: 'bottom'
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                let label = (context.dataset.label || '') + ': ' + context.parsed.y;
                                if (context.dataset.yAxisID == 'y1') {
                                    return label + '%';
                                }
                                if (context.parsed.y > 0) {
                                    label += ' (' + positiveTooltip + ')';
                                } else {
                                    label += ' (' + negativeTooltip + ')';
                                }
                                return label;
                            }
                        }
                    }
                },
                scales: {
                    y: {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        title: {
                            display: true,
                            text: yTitle
                        },
                    },
                    y1: {
                        type: 'linear',
                        display: true,
                        position: 'right',
                        title: {
                            display: true,
                            text: y1Title
                        },
                        ticks: {
                            callback: (value, index, values) => {
                                return `${value}%`
                            }
                        },
                        // grid line settings
                        grid: {
                            drawOnChartArea: false, // only want the grid lines for one axis to show up
                        },
                    },
                }
            },
            data: tsoHistoricData
        }
    );
    //chart.options.plugins.legend.position = 'bottom';
    //chart.update();
})();

$(document).ready(function () {

    document.querySelectorAll('.btnHistoric').forEach(button => {
        button.addEventListener("click", (e) => {
            document.getElementById('divMap').classList.add("d-none");
            document.getElementById('divHistoric').classList.remove("d-none");
            document.getElementById('divFlow').classList.add("d-none");
        });
    });
    document.querySelectorAll('.btnFlow').forEach(button => {
        button.addEventListener("click", (e) => {
            e.preventDefault();
            document.getElementById('divMap').classList.add("d-none");
            document.getElementById('divHistoric').classList.add("d-none");
            document.getElementById('divFlow').classList.remove("d-none");

            initSvgMap();
        });
    });
    document.getElementById('flowShowRegions').addEventListener("click", (e) => {
            //e.preventDefault();
            //alert(e.currentTarget.val);
            let regions = document.getElementById('betaplalasi_regiok');
            if(e.currentTarget.checked) {
                regions.classList.remove("d-none");
            } else {
                regions.classList.add("d-none");
            }
        });

    document.querySelectorAll('.btnHistoric').forEach(button => {
        button.addEventListener("click", (e) => {
            document.getElementById('divMap').classList.add("d-none");
            document.getElementById('divHistoric').classList.remove("d-none");
            document.getElementById('divFlow').classList.add("d-none");
        });
    });

    document.querySelectorAll('.btnActual').forEach(button => {
        button.addEventListener("click", (e) => {
            document.getElementById('divMap').classList.remove("d-none");
            document.getElementById('divHistoric').classList.add("d-none");
            document.getElementById('divFlow').classList.add("d-none");
        });
    });

    function initSvgMap() {
        // Initialize panZoom only if it hasn't been initialized yet
        if (!panZoom) {
            // Initialize after a small delay to ensure the element is visible
            setTimeout(() => {
                panZoom = svgPanZoom('#zoom-map', {
                    zoomEnabled: true,
                    panEnabled: true,
                    controlIconsEnabled: false,
                    zoomScaleSensitivity: 0.5,
                    fit: true,
                    center: true,
                    contain: true,
                    minZoom: 1,
                    maxZoom: 10,
                });
            }, 50);
        }
    }
    if(!document.getElementById('divFlow').classList.contains("d-none")) {
        initSvgMap();
    }

    function clearTsoFlowModal(key) {
        document.getElementById('tsoFLowModalTitle'+key).innerHTML = '';
        document.getElementById('tsoflowModalBody'+key).innerHTML = '';
    }

    function showFlowChart(tsoFlowData, key) {
        // Get the chart instance if it exists
        const canvas = document.getElementById('gasFlowData'+key);
        const chartInstance = Chart.getChart(canvas);

        // If a chart instance exists, destroy it
        if (chartInstance) {
            chartInstance.destroy();
        }

        let chart = new Chart(
            document.getElementById('gasFlowData'+key),
            {
                type: 'line',
                options: {
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: true,
                            position: 'bottom'
                        },
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    let label = (context.dataset.label || '') + ': ' + context.parsed.y;
                                    if (context.dataset.yAxisID == 'y1') {
                                        return label + '%';
                                    }
                                    if (context.parsed.y > 0) {
                                        label += ' (' + positiveTooltip + ')';
                                    } else {
                                        label += ' (' + negativeTooltip + ')';
                                    }
                                    return label;
                                }
                            }
                        }
                    },
                    scales: {
                        y: {
                            type: 'linear',
                            display: true,
                            position: 'left',
                            min: 0,
                            title: {
                                display: true,
                                text: tsoFlowData.yTitle
                            },
                        },
                    }
                },
                data: tsoFlowData
            }
        );
        document.getElementById('tsoflowPoint'+key).classList.remove("d-none");
    }

    document.querySelectorAll('.tsoFlowPoint').forEach(button => {
        const handler = (e) => {
            e.preventDefault();


            let eic = button.dataset.eic;
            if (!eic) return;

            document.getElementById('tsoflowPoint0').classList.add("d-none");
            document.getElementById('tsoflowPoint1').classList.add("d-none");
            document.getElementById('tsoflowPoint2').classList.add("d-none");

            axios.get('/ajax/gasflow/getPoint', {
                params: {
                    eic: eic,
                    locale: locale
                }
            }).then(function (response) {
                if (response.data) {
                    let key = 0;
                    response.data.forEach(point => {
                        document.getElementById('tsoFLowModalTitle'+key).innerHTML = point.dimNetworkPointName;
                        document.getElementById('spanTsoFLowPointEIC'+key).innerHTML = point.dimNetworkPointEICCode;

                        const aggregatedSpan = document.getElementById('spanTsoFLowPointAggregated'+key);
                        const aggregatedLi = document.getElementById('liTsoFLowPointAggregated'+key);

                        if (point.componentPoints) {
                            aggregatedSpan.innerHTML = point.componentPoints;
                            aggregatedLi.classList.remove("d-none");
                        } else {
                            aggregatedSpan.innerHTML = '';
                            aggregatedLi.classList.add("d-none");
                        }

                        showFlowChart(point.chart, key);


                        key = key+1;
                    });
                    document.getElementById('btnToggleTsoFLowModal').click();

                }
            }).catch(function (error) {
                console.log(error);
            });
        };

        button.addEventListener("click", handler);
        button.addEventListener("touchstart", handler); // touch támogatás
    });


    $('input[name="daterange"]').daterangepicker({
        locale: {
            format: 'YYYY-MM-DD',
        },
        minDate: minDate,
        maxDate: maxDate,
        maxSpan: {
            days: maxSpan
        },
        opens: 'left'
    }, function (start, end, label) {
        document.getElementById('inputHistoricRange').value = start.format('YYYY-MM-DD') + '<>' + end.format('YYYY-MM-DD');
        document.getElementById('formHistoricForm').submit();
        //console.log("A new date selection was made: " + start.format('YYYY-MM-DD') + ' - ' + end.format('YYYY-MM-DD'));
    });

    // Declare a variable to store the panZoom instance
    let panZoom = null;

    /*const panZoom = svgPanZoom('#zoom-map', {
        zoomEnabled: true,
        panEnabled: true,
        controlIconsEnabled: false,
        zoomScaleSensitivity: 0.5,
        fit: true,
        center: true,
        contain: true,
        minZoom: 1,
        maxZoom: 10,
    });*/

    document.getElementById('zoom-in').addEventListener('click', function (e) {
        e.preventDefault();
        panZoom.zoomIn();
    });

    document.getElementById('zoom-out').addEventListener('click', function (e) {
        e.preventDefault();
        panZoom.zoomOut();
    });

    document.getElementById('reset').addEventListener('click', function (e) {
        e.preventDefault();
        panZoom.resetZoom();
        panZoom.resetPan();
    });

});
